import { Injectable } from '@angular/core';
import * as AOS from 'aos';

@Injectable({
  providedIn: 'root'
})
export class AosService {

  init(): void {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }

  refresh(): void {
    AOS.refresh();
  }
}